module.exports = __webpack_public_path__ + "img/milestone__1953.f74f82ca.jpg";